module.exports = {
	"welcome": "Bem-vindo <strong>%{name}</strong>",
	"actions": {
		"enter": "Entrar",
		"save": "Salvar"
	},
	"models": {
		"user": {
			"username": "Nome de usuário",
			"password": "Senha"
		}
	},
	"pages": {
		"login": {
			"title": "Entrar",
			"tip": "Dica <code>admin:123</code>"
		}
	},
	"modules": {
		"posts": {
			"new": "Nova postagem",
			"edit": "Editar postagem",
			"fields": {
				"created_at": "Data de publicação",
				"title": "Título",
				"body": "Texto"
			},
			"help": {
				"created_at": "Digite a data de publicação",
				"title": "Digite um título",
				"body": "Digite o texto"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/locales/pt-BR.json
// module id = 230
// module chunks = 2